import React from "react";
import "./medicalTreatmentRecordTable.css";
import { formatRupiah } from "../../../helper/formatNumber";

const MedicalTreatmentRecordTable = ({ page, medicalTreatmentRecords }) => {
  return (
    <div className="medical-record-table-container">
      <table className="medical-record-table">
        <thead>
          <tr>
            <th>Tindakan Medis</th>
            <th>Tarif Tindakan Medis</th>
            <th>Jumlah Transaksi</th>
            <th>Total Transaksi</th>
          </tr>
        </thead>
        <tbody>
          {medicalTreatmentRecords.length > 0 ? (
            medicalTreatmentRecords.map((treatment, index) => (
              <tr key={index}>
                <td>{treatment.medical_transaction_name}</td>
                <td>{formatRupiah(treatment.service_per_transaction)}</td>
                <td>{treatment.total_transaction}</td>
                <td>{formatRupiah(treatment.total_service_fee)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default MedicalTreatmentRecordTable;
